// MpfMessageCard.props.ts
// Not in NHS DS — built on their Card, type-scale and spacing foundations.
import type { HeadingLevel, HeadingLevelSize } from '../MpfInput/MpfInputBaseProps';

export type MpfMessageDirection = 'inbound' | 'outbound';

export interface MpfMessageCardProps {
  direction: MpfMessageDirection;
  title?: string | null;
  sentAt: string;
  sentAtPrefix?: string;
  headingLevel?: HeadingLevel;
  headingLevelSize?: HeadingLevelSize;
}

export const mpfMessageCardDefaults = {
  title: null,
  sentAtPrefix: 'Sent',
  headingLevel: 2,
  headingLevelSize: 's',
} satisfies Partial<MpfMessageCardProps>;
